module.exports = __webpack_public_path__ + "static/media/bkg_3.6bab30a8.jpg";